import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/credit card.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import List from "./styledComponents/Table/List";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import { Modal } from "antd";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import swal from "sweetalert";
import FETCH from "../utils/fetch";
import Loader from "../components/styled-components/loader/loader";
import moment from "moment";
import { ToolTipCreator } from "../helpers/ToolTipCreator";

export const AssetsandLiabilites = () => {
  const Assetscols = [
    {
      title: "Name of Asset",
      dataIndex: "Name of Asset",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Asset Type",
      dataIndex: "module",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Account Type",
      dataIndex: "Account Type/Titled",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Held Where",
      dataIndex: "Held Where",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Value",
      dataIndex: "Monetary Value",
      render: (record) =>
        record
          ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : "N/A",
    },
    {
      title: "Value as of Date",
      dataIndex: "Value as of Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },

    // {
    //   title: "Action",
    //   render: (record, index) => {
    //     // console.log("index...>>>",record.idx);
    //     return (
    //       <div>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginRight: "1rem" }}
    //           src={menuIcon}
    //           alt="menuIcon"
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const Loancols = [
    {
      title: "Name of Credit ",
      dataIndex: "Nickname of Credit",
      key: "Nickname of Credit",
      render: (record) => (record ? record : "N/A"),
    },
    // {
    //   title: "Credit Description",
    //   dataIndex: "module",
    //   render: (record) => (record ? record : "N/A"),
    // },
    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Bank",
      dataIndex: "Bank",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Credit Limit",
      dataIndex: "Credit Limit",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },
    {
      title: "Interest Rate(or APR%)",
      dataIndex: "Interest Rate (or APR%)",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Credit Balance",
      dataIndex: "Credit Balance",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    // {
    //   title: "Action",
    //   render: (record, index) => {
    //     // console.log("index...>>>",record.idx);
    //     return (
    //       <div>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginRight: "1rem" }}
    //           src={menuIcon}
    //           alt="menuIcon"
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const Creditscols = [
    {
      title: "Name of Liability",
      dataIndex: "Nickname of Liabilities",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Owner",
      dataIndex: "Owner",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Financial Institution",
      dataIndex: "Name of Financial Institution",
      render: (record) => (record ? record : "N/A"),
    },
    // {
    //   title: "Credit Balance",
    //   dataIndex: "Credit Balance",
    //   render: (record) => (record ? record : "N/A"),
    // },
    {
      title: "Monthly Payment",
      dataIndex: "Monthly Payment",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    {
      title: "Interest Rate (or APR%)",
      dataIndex: "Interest Rate",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Maturity Date",
      dataIndex: "Maturity Date",
      render: (record) =>
        record ? moment(record).format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "Loan Balance",
      dataIndex: "Initial Loan Amount",
      render: (record) =>
        record
          ? !isNaN(record)
            ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
          : "N/A",
    },

    // {
    //   title: "Action",
    //   render: (record, index) => {
    //     // console.log("index...>>>",record.idx);
    //     return (
    //       <div>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginRight: "1rem" }}
    //           src={menuIcon}
    //           alt="menuIcon"
    //         ></img>{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const [tooltipModal, setTooltipModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [accountAsset, setAccountAsset] = useState([]);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [creditRows, setCreditRows] = useState([]);

  const getAssetsList = async () => {
    try {
      (async () => {
        // this.props.handleLoader();
        setLoading(true);
        const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
        const ID = localStorage.getItem("accessId");

        let data = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: userRole === "Financial Advisor Client"
            ? `?module=Asset&page=1&limit=10&clientId=${ID}`
            : `?module=Asset&page=1&limit=10`,
          body: {},
        });
        setLoading(false);
        // this.props.handleLoader();
        // console.log("Account Asset and libalities...",data.records)
        if (data && data.records) {
          setAccountAsset(data.records);
          // this.setState({
          //   account_asset:
          //     data.records.map(item => {
          //       return {
          //         ...item,
          //         AssetName: item['Name of Asset'],
          //         AccountType: item['Account Type/Titled'],
          //         HeldWhere: item['Held Where'],
          //         MonetaryValue: item['Monetary Value']
          //       }
          //     })
          // })
        }

        // this.props.handleLoader();
        setLoading(true);
        
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=1&limit=10&clientId=${ID}`
            :`?module=Liabilities and Credit&page=1&limit=10`,
          body: {},
        });
        // this.props.handleLoader();
        setLoading(false);
        // console.log("Account Asset and libalities...",data.records)
        if (datares && datares.records) {
          datares.records.map((item) => {
            if (item["subType"] === "Credit") {
              console.log("here in credit");
              setCreditRows((prevState) => [...prevState, item]);

              // setCreditRows((prev) => ({
              //   ...prev,
              //   item,
              // }));
              // this.setState(prevState => ({
              //   credit_rows: [...prevState.credit_rows, item]
              // }))
            } else {
              console.log("here in liabilities");
              setLiabilitesCredit((prevState) => [...prevState, item]);
              // setLiabilitesCredit((prevState) => [...prevState, item]);
              // this.setState(prevState => ({
              //   liabilities_credit: [...prevState.liabilities_credit, item]
              // }))
            }
          });
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
      // this.props.handleLoader()
    }
  };
  console.log("liabilitiesCredit", liabilitiesCredit);
  console.log("creditRows", creditRows);

  useEffect(() => {
    console.log("calling api");
    getAssetsList();
  }, []);
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  return (
    <div>
      {" "}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Assets and Liabilities</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              This program feature is pulling information found in Asset Planet
              the software for Organizing Planning and Protecting. The death
              module is part of the 4 D’s of the Asset Planet program- the
              others being Disability, Disaster and Divorce. The Death module is
              retrieving information found in Assets and Liabilities modules.
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {tooltipModal && (
              <video style={{ width: "25rem" }} controls>
                <source
                  src={
                    "https://assets-planet.s3.amazonaws.com/media/ad34f017-3399-4b17-8084-32efc0e1c1fd.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        </div>
      </Modal>
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Assets and Liabilities{" "}
          <ToolTipCreator name={"Death_Assets_and_Liabilities"}/>
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon> */}
      </Style.MainHeading>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Assets Details</Style.Title>
          <div></div>
        </Style.HealthCardHeader>
        <List cols={Assetscols} rows={accountAsset}></List>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Liability Details
            <span style={{ color: "#A8ADB7" }}>
              /Existing Loans (Not Credit Card)
            </span>
          </Style.Title>
          <div></div>
        </Style.HealthCardHeader>
        <List cols={Creditscols} rows={liabilitiesCredit}></List>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Liability Details
            <span style={{ color: "#A8ADB7" }}>
              /Credit Lines (Bank or Credit Card)
            </span>
          </Style.Title>
          <div></div>
        </Style.HealthCardHeader>
        <List cols={Loancols} rows={creditRows}></List>
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
